// src/lib/blogCategories.js
export const BLOG_CATEGORIES = [
  'Web Development',
  'AI & Automation',
  'Social Media',
  'SEO',
  'Business Growth',
  'Case Studies',
]
